import { AlertType, OptionType } from 'src/app/core/enums/enums';
import { InvoluntaryChangeService } from 'src/app/involuntary-change/services/involuntary-change.service';
import { Subscription } from 'rxjs';
import { PassengerQuote, PnrInfo, QuoteRequest } from 'src/app/core/models/itinerary.model';
import { MiniState } from 'src/app/core/models/models';
import { ReRouteService } from 'src/app/re-route/services/re-route.service';
import { IRerouteUpdateQuoteRequest } from 'src/app/core/models/re-route.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-re-route-split-step',
  templateUrl: './re-route-split-step.component.html',
  styleUrls: ['./re-route-split-step.component.scss']
})
export class ReRouteSplitStepComponent implements OnChanges, OnDestroy {
  @Input() pnrInfo: PnrInfo;
  @Input() selectedPassengers: PassengerQuote[] = [];

  @Output() splitIsDone = new EventEmitter<boolean>();

  splitAppState: MiniState;
  splitState: AlertType = AlertType.Warning;
  alertType = AlertType;
  subscriptions = new Subscription();
  newPnr: string;
  reRouteSplitQuote: QuoteRequest;
  flightIndexes: number[] = [];

  constructor(
    private involChangeService: InvoluntaryChangeService,
    private reRouteService: ReRouteService,
    private itiService: ItineraryService
  ) {
    this.subscriptions.add(
      this.involChangeService.getSplitState().subscribe((state) => {
        this.reRouteService.dispatchSaveLoadingState(false);
        this.newPnr = state?.data?.code;
        this.splitAppState = state;
        this.splitState = state?.state;

        if (this.splitState === AlertType.Success) {
          this.editReRouteQuoteRequest(state.data);
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (
        changes.pnrInfo &&
        changes.selectedPassengers &&
        changes.pnrInfo.currentValue &&
        changes.selectedPassengers.currentValue
      ) {
        this.getFlightIndexes(changes.pnrInfo.currentValue);
        this.buildReRouteSplitQuote(changes.pnrInfo.currentValue);
      }
    }
  }

  editReRouteQuoteRequest(pnrInfo: PnrInfo) {
    this.subscriptions.add(
      this.itiService.getSelectedPassengersQuote().subscribe((passengers) => {
        const updatedData: IRerouteUpdateQuoteRequest = {
          pnr: pnrInfo.code,
          country: pnrInfo.countryCode,
          gds: pnrInfo.gds,
          bookingCode: pnrInfo.code,
          transactionId: pnrInfo.transactionId,
          officeId: pnrInfo.officeId,
          passengers
        };
        this.reRouteService.dispatchUpdateReRouteQuoteRequest(updatedData);
      })
    );
  }

  getFlightIndexes(info: PnrInfo) {
    info.itinerary.segments.forEach((segment) => {
      segment.flights.forEach((flight) => {
        this.flightIndexes.push(flight.index);
      });
    });
  }

  buildReRouteSplitQuote(info: PnrInfo) {
    this.reRouteSplitQuote = {
      comission: 0,
      country: info.countryCode,
      flights: this.flightIndexes,
      gds: info.gds,
      isException: info.isIssueException,
      officeId: info.officeId,
      passengers: this.selectedPassengers,
      pnr: info.code,
      pnrOption: OptionType.InvoluntaryChange
    };
  }

  splitPNR() {
    this.involChangeService.dispatchRequestSplit(this.reRouteSplitQuote);
    this.reRouteService.dispatchSaveLoadingState(true);
  }

  splitPNRSuccess() {
    this.splitIsDone.emit(true);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
